import { BlueprintService } from "../cases/blueprint/BlueprintService";
import { GenerateService } from "../cases/blueprint/GenerateService";
export class RegisterBlueprint {
    static configure(container) {
        const it = (serviceIdentifier) => {
            return container.get(serviceIdentifier);
        };
        container.bind(GenerateService).toConstantValue(new GenerateService());
        container.bind(BlueprintService).toConstantValue(new BlueprintService(it(GenerateService)));
    }
}
